import React from "react";
import "./about.css";

export default function About() {
  return (
    <main className="about">
      {/* HERO */}
      <section className="aboutHero">
        <div className="aboutHero__container">
          <div className="aboutHero__left">
            <h1>About Tote Therapy</h1>
            <p className="aboutHero__lead">
              We create calm you can carry — thoughtful designs made to slow down
              busy days.
            </p>

            <div className="aboutHero__stats">
              <div className="stat">
                <h3>Crafted with love</h3>
                <p> Thoughtfully created</p>
              </div>
              <div className="stat">
                <h3>Premium & Sustainable</h3>
                <p>Quality materials. Conscious choices.</p>
              </div>
              <div className="stat">
                <h3>Everyday Essentials</h3>
                <p>Designed for you — and for everyone</p>
              </div>
            </div>
          </div>

         <div className="aboutHero__right">
  <div className="aboutImages">
    <div className="aboutImage">
      <img src="/red.png" alt="Tote Therapy 1" />
    </div>

    <div className="aboutImage">
      <img src="/red1.jpeg" alt="Tote Therapy 2" />
    </div>

    <div className="aboutImage">
      <img src="/red2.png" alt="Tote Therapy 3" />
    </div>
  </div>
</div>
        </div>
      </section>

      {/* STORY */}
      <section className="aboutSection">
        <div className="aboutSection__container">
          <div className="aboutCard">
            <h2>🌿 Our Story</h2>
            <p className="born">Tote Therapy was born in the heart of Dubai — a city that moves 24/7.</p>
            <p>
              In a place driven by ambition, deadlines, and constant momentum, life can quickly become a cycle
              of wake up, work, eat, sleep, and repeat. Somewhere between success and exhaustion, we often forget to pause.
            </p>
             <p className="born">We created Tote Therapy as a quiet reminder in a loud world.</p>
            <p>
              A reminder to breathe.<br />
             A reminder to protect your peace.<br />
            A reminder to stay mentally aware.<br />
          </p>  
          <p>
Each tote is thoughtfully designed with minimal aesthetics and meaningful words created to move with you through everyday life. Whether you’re heading to work,
meeting friends, or simply navigating your routine, your bag becomes more than an accessory.
It becomes a message.
We believe awareness isn’t only emotional it’s environmental too. That’s why our totes are crafted from sustainable, 
reusable materials designed for daily durability and conscious living.
Tote Therapy is not about slowing down your ambition.
It’s about balancing it.
Because even in a city that never stops, your mind deserves space.

Carry your calm.
            </p>
          </div>

        <div className="aboutCard">
  <h2>🌿 What We Believe</h2>

  <ul className="aboutList">
    <li>
      <strong>Awareness is strength.</strong>
      <span>Taking care of your mind is not weakness — it is power.</span>
    </li>

    <li>
      <strong>Rest is productive.</strong>
      <span>Pausing does not mean falling behind.</span>
    </li>

    <li>
      <strong>Words matter.</strong>
      <span>What you wear and carry influences how you feel.</span>
    </li>

    <li>
      <strong>Sustainability is responsibility.</strong>
      <span>Mindful living includes mindful choices.</span>
    </li>

    <li>
      <strong>Calm is confidence.</strong>
      <span>Peace is the ultimate luxury.</span>
    </li>
  </ul>
</div>
        </div>
      </section>

      {/* WHY TOTE THERAPY */}
<section className="aboutFeatures">
  <div className="aboutFeatures__container">
    
    <h2 className="sectionTitle">🌿 Why Tote Therapy?</h2>
    <p className="sectionSub">
      More than a bag — a movement of calm, awareness, and mental wellness.
    </p>

    <div className="featureGrid">

      <div className="feature">
        <h3>Sustainable Canvas</h3>
        <p>Crafted from reusable, eco-conscious materials.</p>
      </div>

      <div className="feature">
        <h3>Eco-Friendly Choice</h3>
        <p>A mindful alternative to single-use plastic bags.</p>
      </div>

      <div className="feature">
        <h3>Daily Durability</h3>
        <p>Strong stitching and structure made for everyday use.</p>
      </div>

      <div className="feature">
        <h3>Intentional Design</h3>
        <p>Minimal aesthetics with meaningful emotional value.</p>
      </div>

      <div className="feature">
        <h3>Mental Awareness</h3>
        <p>Messages that gently promote emotional well-being.</p>
      </div>

      <div className="feature">
        <h3>Dubai Inspired</h3>
        <p>Born in a fast-paced 24/7 city lifestyle.</p>
      </div>

      <div className="feature">
        <h3>Custom Personalization</h3>
        <p>Make it yours with custom quotes or personal touches.</p>
      </div>
<div className="feature">
  <h3>Lightweight & Spacious</h3>
  <p>Comfortable to carry with enough space for your daily essentials.</p>
</div>

<div className="feature">
  <h3>Ethically Produced</h3>
  <p>Created responsibly with care for people and the planet.</p>
</div>
    </div>
  </div>
</section>
{/* LOCATION */}
<section className="aboutLocation">
  <div className="aboutLocation__container">
    <div className="locationCard">
      <div className="locationLeft">
        <h2>📍 Our Location</h2>
        <p className="locationText">
          Inside Capitol Real Estate Compound - Warehouse 17M3, Al Qouz 4,
          Al Asayel Street 17, Sector, Dubai, United Arab Emirates
        </p>

        <div className="locationActions">
          <a
            className="locationBtn"
            href="https://www.google.com/maps/search/?api=1&query=Inside%20Capitol%20Real%20Estate%20Compound%20Warehouse%2017M3%20Al%20Qouz%204%20Dubai"
            target="_blank"
            rel="noreferrer"
          >
            Open in Google Maps
          </a>

          <a className="locationBtn secondary" href="tel:+971000000000">
            Call Us
          </a>
        </div>
      </div>

      <div className="locationRight">
      <iframe
  title="Tote Therapy Location"
  src="https://maps.google.com/maps?q=25.1394,55.2444&z=16&output=embed"
  loading="lazy"
  allowFullScreen
/>
      </div>
    </div>
  </div>
</section>
      {/* CTA */}
      <section className="aboutCTA">
        <div className="aboutCTA__container">
          <div className="ctaBox">
            <h2>Carry Your Calm.</h2>
            <p>
              In a city that never slows down, choose your peace.
            </p>
            <a className="ctaBtn" href="/shop">Shop the Collection →</a>
          </div>
        </div>
      </section>
    </main>
  );
}